
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {HolidayProps} from "types/props-obj/HolidayProps";
import {set} from 'date-fns';

const initialState: HolidayProps = {
    apiEndPoint: "holiday",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    relist: [],
    item: null,
    error: null,
    alertPopup: false
};

const holiday = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);

            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {
            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.relist=state.list .map((tempList:any) => {
                return { title: tempList.title ,start: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 0, minutes: 0 } ),end: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 24, minutes: 0 } ) ,id:tempList.id,description:tempList.description,textColor:tempList.text_color,backgroundColor:tempList.background_color};
            });
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.relist=state.list .map((tempList:any) => {
                return { title: tempList.title ,start: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 0, minutes: 0 } ),end: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 24, minutes: 0 } ) ,id:tempList.id,description:tempList.description,textColor:tempList.text_color,backgroundColor:tempList.background_color};
            });
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.relist=state.list .map((tempList:any) => {
                return { title: tempList.title ,start: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 0, minutes: 0 } ),end: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 24, minutes: 0 } ) ,id:tempList.id,description:tempList.description,textColor:tempList.text_color,backgroundColor:tempList.background_color};
            });
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
            state.relist=state.list .map((tempList:any) => {
                return { title: tempList.title ,start: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 0, minutes: 0 } ),end: set(new Date(tempList?.holiday_date_formatted?? ''),{  hours: 24, minutes: 0 } ) ,id:tempList.id,description:tempList.description,textColor:tempList.text_color,backgroundColor:tempList.background_color};
            });
        },
        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },

    }
});


export default holiday.reducer;

function getApiEndPoint(){
    return store.getState().holiday.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setLoading,setPageLimit,setApiEndPoint } = holiday.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(holiday.actions.setLoading(true));
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(holiday.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(holiday.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(holiday.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(holiday.actions.setItem(response.data));
        } catch (error) {
            dispatch(holiday.actions.hasError(error));
            dispatch(holiday.actions.setLoading(false));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        dispatch(holiday.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(holiday.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(holiday.actions.hasError(error));
            dispatch(holiday.actions.setLoading(false));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(holiday.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(holiday.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(holiday.actions.hasError(error));
            dispatch(holiday.actions.setLoading(false));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(holiday.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(holiday.actions.hasError(error));
        }
    };
}